<kiwi-chart [titleKey]="'decisions.area.restaurants.repartition.title'"
            [labelKey]="'decisions.area.restaurants.number'"
            [barChartLabels]="barChartLabels"
            [barChartData]="barChartData">
    <p><span [i18nKey]="'decisions.area.restaurants.total.number'"></span> {{restaurantsNumber}}</p>
    <p [i18nKey]="'decisions.area.restaurants.repartition'"></p>
</kiwi-chart>
